import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { FundingType } from '@openclassrooms/sdk-web';
import Button, { Props as ClassifyButtonProps } from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import { APPSOURCE_NAMES } from '../../../applications/constants';
import { getAdmissionFunnelLinkProps } from '../../../jobApplications/services/getAdmissionFunnelUrl';
interface ApplyButtonProps extends ClassifyButtonProps {
  pathId?: number;
  children?: ReactNode;
  'data-event'?: string;
  fundingType?: FundingType;
  jobPostingId?: string;
}
export default function ApplyButton(t0) {
  const $ = _c(18);
  let children;
  let fundingType;
  let jobPostingId;
  let pathId;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      "data-event": t1,
      pathId,
      fundingType,
      jobPostingId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = fundingType;
    $[3] = jobPostingId;
    $[4] = pathId;
    $[5] = props;
    $[6] = t1;
  } else {
    children = $[1];
    fundingType = $[2];
    jobPostingId = $[3];
    pathId = $[4];
    props = $[5];
    t1 = $[6];
  }
  const dataEvents = t1 === undefined ? "Navigation|Redirection::Internal|Apply" : t1;
  let t2;
  if ($[7] !== fundingType || $[8] !== jobPostingId || $[9] !== pathId) {
    t2 = getAdmissionFunnelLinkProps(APPSOURCE_NAMES.GENERIC, pathId, fundingType, jobPostingId);
    $[7] = fundingType;
    $[8] = jobPostingId;
    $[9] = pathId;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const linkProps = t2;
  let t3;
  if ($[11] !== children) {
    t3 = children ?? translate("global.apply.cta");
    $[11] = children;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== dataEvents || $[14] !== linkProps || $[15] !== props || $[16] !== t3) {
    t4 = <Button data-event={dataEvents} {...linkProps} {...props} data-testid="genericApplyButton" rel="nofollow">{t3}</Button>;
    $[13] = dataEvents;
    $[14] = linkProps;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}